import React from 'react'
import { useTranslation } from 'react-i18next'
import { match, P } from 'ts-pattern'

import { Typography } from '~/components/elements/Typography'

import { DataSettingsCardSection } from './DataSettingsCardSection'

export type UploadedDateSectionProps = {
  dateString: string | undefined
}

export const UploadedDateSection = ({
  dateString,
}: UploadedDateSectionProps) => {
  const { t } = useTranslation()
  const notUploadedText = t('not_uploaded')

  return (
    <DataSettingsCardSection title={t('data_upload_date')}>
      <Typography fontSize={14} variant="normal">
        {match(dateString)
          .with(undefined, () => notUploadedText)
          .with(P.string, (value) => new Date(Number(value)).toLocaleString())
          .exhaustive()}
      </Typography>
    </DataSettingsCardSection>
  )
}
